module.exports = __webpack_public_path__ + "static/media/Zoran-Vujkov.b9e0e9b9.png";